import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
    state: () => ({
        processing: false,
        snackbar: {
            status: false,
            text: '',
            color: '',
        },
        theme: 'light',
        locale: 'fr',
    }),
    actions: {
        setProcessing(status) {
            this.processing = status
        },
        setSnackbar(snackbar) {
            this.snackbar = snackbar
        },
        initSnackbar() {
            this.snackbar = {
                status: false,
                text: '',
                color: '',
            }
        },
        switchTheme(theme) {
            this.theme = theme
        },
        switchLocale(locale) {
            this.locale = locale
        },
    },
    persist: {
        paths: ['theme', 'locale'],
    },
})
